export default {"src":"/_next/static/media/optimizeContent.5328ca0b.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};